import { Table } from "react-bootstrap";
import { useQueryClient } from "react-query";
import { useToasts } from "react-toast-notifications";
import { useSelector } from "react-redux";

import { toast } from "@/services/Utils";
import { useInitialDataImplementation } from "@/hooks/implementation/firstLoad/initialDataImplementation";
import { useBalancesBulkLoader } from "@/hooks/implementation/firstLoad/bulkLoader";

import MultiSelect from "@/components/Form/MultiSelect/MultiSelect";
import FooterButtons from "../Buttons/FooterButtons";

import { NoOptionsMessage } from "@/components/ReactSelect/NoOptions";

const key = "initial_data_implementation";

const BalanceTableLoad = (props) => {
	const { addToast } = useToasts();
	const queryClient = useQueryClient();
	const { customer } = useSelector((state) => state.auth.user);

	const { mutate, isLoading } = useBalancesBulkLoader();
	const { data } = useInitialDataImplementation();

	const handleInputChange = (index, field, value) => {
		const newBalance = data.balances.map((row, i) => {
			if (i === index) {
				if (field === "estateParents") {
					return {
						...row,
						[field]: data.estateParents.filter((v) => value.map((v) => v.value).includes(v.value)),
					};
				}
				if (field === "estates") {
					return {
						...row,
						[field]: data.estates.filter((v) => value.map((v) => v.value).includes(v.value)),
					};
				}

				return { ...row, [field]: value };
			}
			return row;
		});

		queryClient.setQueryData([key], { ...data, balances: newBalance });
	};

	const validBalances = () => {
		let isValidBalances = true;

		for (let i = 0; i < data?.balances.length; i++) {
			const balance = data?.balances[i];

			if (balance.estates.length === 0) {
				isValidBalances = false;
				toast(addToast, "Se requiere que las balanzas tengan  bodegas asignadas", "error");
				break;
			}
		}

		return isValidBalances;
	};

	const saveBalances = ({ moveForward = false }) => {
		if (validBalances()) {
			const queryData = { ...queryClient.getQueryData([key]) };
			queryData.implementationStep = moveForward ? data.implementationStep + 1 : data.implementationStep;

			mutate(queryData, {
				onSuccess: (response) => {
					if (Object.prototype.hasOwnProperty.call(response, "balances")) {
						toast(addToast, response.message, "success");

						queryClient.setQueryData([key], {
							...data,
							balances: response.balances,
							implementationStep: response.implementationStep,
						});

						if (props.formWizardRef.current?.nextTab && moveForward) {
							props.formWizardRef.current.nextTab();
						}
					}
				},
			});
		}
	};

	return (
		<>
			<Table hover>
				<thead>
					<tr>
						<th className="border-0">
							Nombre <small className="text-danger">*</small>
						</th>
						{!!customer.use_estates_parents && (
							<th className="border-0">
								Campos <small className="text-danger">*</small>
							</th>
						)}
						<th className="border-0">
							Bodegas <small className="text-danger">*</small>
						</th>
					</tr>
				</thead>
				<tbody>
					{data.balances.map((balance, index) => {
						return (
							<tr key={balance.id}>
								<td className="position-relative">
									<span>{balance.name ? balance.name : ""}</span>
								</td>
								{!!customer.use_estates_parents && (
									<td className="position-relative">
										<MultiSelect
											key={`estate_parent_selector_${index}`}
											options={data.estateParents}
											onChange={(e) => handleInputChange(index, "estateParents", e)}
											value={balance.estateParents ? balance.estateParents : []}
											isSelectAll={true}
											menuPlacement={"bottom"}
											placeholder={"Selecciona campos"}
											components={{
												NoOptionsMessage,
											}}
										/>
									</td>
								)}
								<td className="position-relative">
									<MultiSelect
										key={`estate_selector_${index}`}
										options={data.estates}
										onChange={(e) => handleInputChange(index, "estates", e)}
										value={balance.estates ? balance.estates : []}
										isSelectAll={true}
										menuPlacement={"bottom"}
										placeholder={"Selecciona bodegas"}
										components={{
											NoOptionsMessage,
										}}
									/>
								</td>
							</tr>
						);
					})}
				</tbody>
			</Table>

			<FooterButtons wizard={props.formWizardRef} currentIndex={props.index} handleSave={saveBalances} isLoading={isLoading} />
		</>
	);
};

export default BalanceTableLoad;
